import React, { useMemo } from 'react';

import { TeamsNavigationProvider } from '@atlaskit/teams-app-internal-navigation/teams-navigation-provider';

import { useGeneratePath } from '@townsquare/router/primitives/path';
import { useRouter } from '@townsquare/router/useRouter';
import { teamsAppForYouRoute } from '@townsquare/routes/teams-app-for-you-view';

export const TeamsNavigationProviderWrapper = ({
	children,
}: {
	children: React.ReactNode;
}):
	| string
	| number
	| boolean
	| React.JSX.Element
	| Iterable<React.ReactNode>
	| null
	| undefined => {
	const [, routerActions] = useRouter();

	const peopleDirectoryPath = useGeneratePath(teamsAppForYouRoute);

	const value = useMemo(
		() => ({
			navigate: routerActions.push,
			contextEntryPoint: peopleDirectoryPath,
		}),
		[routerActions.push, peopleDirectoryPath],
	);

	return <TeamsNavigationProvider value={value}>{children}</TeamsNavigationProvider>;
};
